/*
 * File: Topbar.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/10/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import { AppBar, Grid, Toolbar, Typography } from "@material-ui/core";

import NavigationMenu from "./NavigationMenu";
import UserMenu from "./UserMenu";

const Topbar = ({ appName }) => {
  return (
    <AppBar color="primary" position="static">
      <Toolbar>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography variant="h6">{appName}</Typography>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" spacing={3}>
              <Grid item>
                <NavigationMenu />
              </Grid>
              <Grid item>
                <UserMenu />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  appName: PropTypes.string.isRequired
};

export default observer(Topbar);
